import React, { useState, useEffect } from "react";
import { getUserDetailsById, updateUserDetails } from "../../../Services/UserService";

const ProfileInformation = () => {
  const [userData, setUserData] = useState({
    name: "",
    phone: "",
    email: "",
    dateOfBirth: "",
    password: ""
  });
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false); // 👈 new state for loader during update

  useEffect(() => {
    const fetchUserDetails = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        console.error("User ID not found");
        setLoading(false);
        return;
      }

      try {
        const response = await getUserDetailsById(userId);

        if (response.data) {
          let formattedDob = "";
          if (response.data.dateOfBirth) {
            const dob = response.data.dateOfBirth.split("T")[0];
            formattedDob = dob;
          }

          setUserData({
            name: response.data.name || "",
            phone: response.data.phone || "",
            email: response.data.email || "",
            dateOfBirth: formattedDob,
            password: ""
          });
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpdate = async () => {
    setUpdating(true); // 👈 show loader
    try {
      const userId = localStorage.getItem("userId");
      const response = await updateUserDetails(parseInt(userId), userData);

      if (response?.status || response?.status === true) {
        const updatedData = { ...response.data };

        if (updatedData.dateOfBirth) {
          const dob = updatedData.dateOfBirth.split("T")[0];
          updatedData.dateOfBirth = dob;
          updatedData.password = ""; // Clear password field after update
        }

        localStorage.setItem("userName", updatedData.name);
        localStorage.setItem("email", updatedData.email);
        localStorage.setItem("phoneNumber", updatedData.phone);

        setUserData(updatedData);
      } else {
        alert("Something went wrong while updating the profile.");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile. Please try again.");
    } finally {
      setUpdating(false); // 👈 hide loader
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="main-content">
      <div className="row g-4">
        <div className="col-md-6">
          <div className="form-input">
            <label htmlFor="name" className="form-label text-uppercase">
              Name <span className="required">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              name="name"
              value={userData.name}
              onChange={handleInputChange}
              placeholder="Thomas W. Holmes"
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-input">
            <label htmlFor="phone" className="form-label text-uppercase">
              Mobile No <span className="required">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="phone"
              name="phone"
              value={userData.phone}
              onChange={handleInputChange}
              placeholder="000-000-0000"
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-input">
            <label htmlFor="email" className="form-label text-uppercase">
              Email <span className="required">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="email"
              name="email"
              value={userData.email}
              onChange={handleInputChange}
              placeholder="abc@gmail.com"
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-input">
            <label htmlFor="dateOfBirth" className="form-label text-uppercase">
              DOB <span className="required">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              id="dateOfBirth"
              name="dateOfBirth"
              value={userData.dateOfBirth || ""}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {/* <div className="col-md-6">
          <div className="form-input">
            <label htmlFor="password" className="form-label text-uppercase">
              Password
            </label>
            <input
              type="text"
              className="form-control"
              id="password"
              name="password"
              value={userData.password}
              onChange={handleInputChange}
              placeholder="********"
            />
          </div>
        </div> */}

        <div className="col-12">
          <div className="d-flex align-items-center justify-content-end">
            <button
              className="button btn-solid"
              onClick={handleUpdate}
              disabled={updating} // disable button while updating
            >
              {updating ? "Updating..." : "Update"} {/* 👈 loader text */}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileInformation;